import React from 'react'
import '../index.css'
import portfolio from '../1.jpg'
const About = () => {
    return (
        <div className="About p-5" id="About">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                    <h1>ABOUT</h1>
                    <img src={portfolio} ></img>    
                    </div>
                    <div className="col-lg-4 pt-4">
                    <p className="pt-5" style={{color:'#C36A2D' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>  
                    </div>    
                </div>
            </div>
        </div>
    )
}

export default About
